import merge from "lodash.merge"
import {transformVehicle} from "../util/Validators";

export function RegisterYourInterestDirectCall(brand, config , enabled = false) {
    return {
        start: function (urlVehicle) {
            if(brand.name == "Leapmotor"){
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "register interest",
                    virtualPageURL: "/lpmi/register-interest/step1",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//register-interest",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "",
                    mainStepIndicator: "1",
                    mainStepName: "personal details",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: urlVehicle,
                    vehicleCategory: "pc",
                    vehicleEngineType: ""
                });
            }
            if (window._satellite) {
                window._satellite.track('ryi-start');
            }

        },
        complete: function (model, year, postcode, marketingOptIn, email , digitalData, window) {
            if(brand.name == "Leapmotor"){
                var engine_type = "BEV";
                if (model.toLowerCase().includes("reev")) {
                    engine_type = "PHEV";
                }
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "register interest",
                    virtualPageURL: "/lpmi/register-interest/step2/confirmation",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//register-interest",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "lead:register-interest",
                    mainStepIndicator: "2",
                    mainStepName: "confirmation",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: model,
                    vehicleCategory: "pc",
                    vehicleEngineType: engine_type
                });
                window.parent.postMessage("iframeFormSubmitted", "*");
            }
            const yr =  year !== undefined ? year : config[transformVehicle(model)].year;
            if (enabled && window.parentIFrame) {
                const message = {
                    type: 'track',
                    track: 'ryi-complete',
                    digitalData: merge(digitalData, {
                            page: {
                                pageInfo: {
                                    vehicleBrand: brand.name.toLowerCase(),
                                    vehicleModel: config[transformVehicle(model)].displayname,
                                    carSize: config[transformVehicle(model)].carsize,
                                    vehicleModelYear: yr

                                },
                                component: {
                                    vehicle: model,
                                    year: yr,
                                    optServices: marketingOptIn ? "Yes" : "No",
                                    form: {
                                        selfReportedZip: postcode,
                                        vehiclesOfInterest: `${yr} ${config[transformVehicle(model)].displayname}`,
                                        marketingEmailAddress : email,
                                    }
                                },
                            }

                        }
                    )
                };
                window.parentIFrame.sendMessage(message);
            }

        },
        error: function () {
        }
    }
}
export function RegisterYourInterestRFCDirectCall(brand, config , enabled = false) {
    return {
        start: function () {
            if (window._satellite) {
                window._satellite.track('ryi-rfc-start');
            }

        },
        complete: function (postcode, marketingOptIn, email , digitalData, window) {
            if (enabled && window.parentIFrame) {
                const message = {
                    type: 'track',
                    track: 'ryi-rfc-complete',
                    digitalData: merge(digitalData, {
                            page: {
                                pageInfo: {
                                },
                                component: {
                                    optServices: marketingOptIn ? "Yes" : "No",
                                    form: {
                                        selfReportedZip: postcode,
                                        marketingEmailAddress : email,
                                    }
                                },
                            }

                        }
                    )
                };
                window.parentIFrame.sendMessage(message);
            }

        },
        error: function () {
        }
    }
}
export function WFFHDirectCall(brand, config , owner = false, enabled = false) {
    return {
        start: function () {
            if (window._satellite) {
                window._satellite.track(owner ? "wffh-owner-start" : "wffh-consumer-start");
            }

        },
        complete: function (postcode, marketingOptIn, email , digitalData, window) {
            if (enabled && window.parentIFrame) {
                const message = {
                    type: 'track',
                    track: owner ? "wffh-owner-complete" : "wffh-consumer-complete",
                    digitalData: merge(digitalData, {
                            page: {
                                pageInfo: {
                                    vehicleBrand: brand.name.toLowerCase(),

                                },
                                component: {
                                    optServices: marketingOptIn ? "Yes" : "No",
                                    form: {
                                        selfReportedZip: postcode,
                                        marketingEmailAddress : email,
                                    }
                                },
                            }

                        }
                    )
                };
                window.parentIFrame.sendMessage(message);
            }

        },
        error: function () {
        }
    }
}

export function RequestAVirtualDemoDirectCall(brand, config , enabled = false) {
    return {
        start: function () {
            if (window._satellite) {
                window._satellite.track('savd-start');
            }

        },
        complete: function (model, year, postcode, availablenow , testdrivetimingdate,testdrivetimingtime, marketingOptIn = false, email ,  digitalData, window) {
            if (enabled && window.parentIFrame) {
                const yr =  year !== undefined ? year : config[transformVehicle(model)].year;

                const message = {
                    type: 'track',
                    track: 'savd-complete',
                    digitalData: merge(digitalData, {
                            page: {
                                pageInfo: {
                                    vehicleBrand: brand.name.toLowerCase(),
                                    vehicleName: config[transformVehicle(model)].displayname,
                                    vehicleModel: config[transformVehicle(model)].displayname,
                                    carSize: config[transformVehicle(model)].carsize,
                                    vehicleModelYear: yr

                                },
                                component: {
                                    vehicle: config[transformVehicle(model)].displayname,
                                    year: yr,
                                    optServices: marketingOptIn ? "Yes" : "No",
                                    prefferedTime: availablenow ? "now" : testdrivetimingdate  + " " + testdrivetimingtime ,
                                    form: {
                                        selfReportedZip: postcode,
                                        vehiclesOfInterest: `${yr} ${config[transformVehicle(model)].displayname}`,
                                        timeframe: availablenow ? "now" : testdrivetimingdate  + " " + testdrivetimingtime,
                                        marketingEmailAddress : email,

                                    }
                                },
                            }

                        }
                    )
                };
                window.parentIFrame.sendMessage(message);
            }
        },
        error: function () {
        }
    }

}


export function RequestATestDriveDirectCall(brand, config , enabled = false) {
    return {
        start: function () {
            if(brand.name == "Leapmotor"){
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "test drive request",
                    virtualPageURL: "/lpmi/test-drive-request/step1",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//request-a-test-drive",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "",
                    mainStepIndicator: "1",
                    mainStepName: "personal details",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: "",
                    vehicleCategory: "pc",
                    vehicleEngineType: ""
                });
            }
            if (window._satellite) {
                window._satellite.track('satd-start');
            }

        },
        complete: function (model, year, postcode, testdrivetiming, marketingOptIn = false, email ,  digitalData, window) {
            if(brand.name == "Leapmotor"){
                var engine_type = "BEV";
                if (model.toLowerCase().includes("reev")) {
                    engine_type = "PHEV";
                }
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "test drive request",
                    virtualPageURL: "/lpmi/test-drive-request/step2/confirmation",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//request-a-test-drive",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "lead:test-drive-request",
                    mainStepIndicator: "2",
                    mainStepName: "confirmation",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: model,
                    vehicleCategory: "pc",
                    vehicleEngineType: engine_type
                });
                window.parent.postMessage("iframeFormSubmitted", "*");
                window.parent.postMessage({
                    type: "iframeFormSubmittedDetails",
                    lead_type: "lead:test-drive-request",
                    model: model,
                    engine_type: engine_type
                }, "*");
                console.log({
                    type: "iframeFormSubmittedDetails",
                    lead_type: "lead:test-drive-request",
                    model: model,
                    engine_type: engine_type
                });
            }
            if (enabled && window.parentIFrame) {
                const yr =  year !== undefined ? year : config[transformVehicle(model)].year;

                const message = {
                    type: 'track',
                    track: 'satd-complete',
                    digitalData: merge(digitalData, {
                            page: {
                                pageInfo: {
                                    vehicleBrand: brand.name.toLowerCase(),
                                    vehicleName: config[transformVehicle(model)].displayname,
                                    vehicleModel: config[transformVehicle(model)].displayname,
                                    carSize: config[transformVehicle(model)].carsize,
                                    vehicleModelYear: yr

                                },
                                component: {
                                    vehicle: config[transformVehicle(model)].displayname,
                                    year: yr,
                                    optServices: marketingOptIn ? "Yes" : "No",
                                    prefferedTime: testdrivetiming,
                                    form: {
                                        selfReportedZip: postcode,
                                        vehiclesOfInterest: `${yr} ${config[transformVehicle(model)].displayname}`,
                                        timeframe: testdrivetiming,
                                        marketingEmailAddress : email,

                                    }
                                },
                            }

                        }
                    )
                };
                window.parentIFrame.sendMessage(message);
                window.parentIFrame.sendMessage({type : "vwo"})
            }
        },
        error: function () {
        }
    }

}

export function RequestAQuoteDirectCall(brand, config , enabled = false) {

    return {
        start: function () {
            if(brand.name == "Leapmotor"){
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "quote request",
                    virtualPageURL: "/lpmi/quote-request/step1",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//request-a-quote",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "",
                    mainStepIndicator: "1",
                    mainStepName: "personal details",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: "",
                    vehicleCategory: "pc",
                    vehicleEngineType: ""
                });
            }
            if (window._satellite) {
                window._satellite.track('gaq-start');
            }
        },
        complete: function (model, year, postcode, marketingOptIn = false, email , digitalData, window) {
            if(brand.name == "Leapmotor"){
                var engine_type = "BEV";
                if (model.toLowerCase().includes("reev")) {
                    engine_type = "PHEV";
                }
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "quote request",
                    virtualPageURL: "/lpmi/quote-request/step2/confirmation",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//request-a-quote",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "lead:quote-request",
                    mainStepIndicator: "2",
                    mainStepName: "confirmation",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: model,
                    vehicleCategory: "pc",
                    vehicleEngineType: engine_type
                });
                window.parent.postMessage("iframeFormSubmitted", "*");
                window.parent.postMessage({
                    type: "iframeFormSubmittedDetails",
                    lead_type: "lead:quote-request",
                    model: model,
                    engine_type: engine_type
                }, "*");
                console.log({
                    type: "iframeFormSubmittedDetails",
                    lead_type: "lead:quote-request",
                    model: model,
                    engine_type: engine_type
                });
            }
            if (enabled && window.parentIFrame) {
                const yr =  year !== undefined ? year : config[transformVehicle(model)].year;

                const message = {
                    type: 'track',
                    track: 'gaq-complete',
                    digitalData: merge(digitalData, {
                            page: {
                                pageInfo: {
                                    vehicleBrand: brand.name,
                                    vehicleName: config[transformVehicle(model)].displayname,
                                    zipCode: postcode,
                                    vehicleModel: config[transformVehicle(model)].displayname,
                                    carSize: config[transformVehicle(model)].carsize,
                                    vehicleModelYear: yr

                                },
                                component: {
                                    vehicle: model,
                                    year: yr,
                                    optServices: marketingOptIn ? "Yes" : "No",
                                    form: {
                                        selfReportedZip: postcode,
                                        vehiclesOfInterest: `${yr} ${config[transformVehicle(model)].displayname}`,
                                        marketingEmailAddress : email,

                                    }
                                },
                            }

                        }
                    )
                };
                window.parentIFrame.sendMessage(message);
            } else if (enabled && !window.digitalData) {
            }
        },
        error: function () {
        }
    }


}

export function RequestABrochureDirectCall(brand, config , enabled = false) {
    return {
        start: function () {
            if(brand.name == "Leapmotor"){
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "brochure request",
                    virtualPageURL: "/lpmi/brochure-request/step1",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//request-a-brochure",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "",
                    mainStepIndicator: "1",
                    mainStepName: "personal details",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: "C10",
                    vehicleCategory: "pc",
                    vehicleEngineType: ""
                });
                console.log("Leapmotor RAB - Start");
            }
            if (window._satellite) {
                window._satellite.track('rab-start');
            }
        },
        complete: function (vehicle, year, postcode, marketingOptIn = false, email , digitalData, window) {
            if(brand.name == "Leapmotor"){
                var engine_type = "BEV";
                if (vehicle.toLowerCase().includes("reev")) {
                    engine_type = "PHEV";
                }
                var dataLayer = window['dataLayer'] || [];
                dataLayer.push({
                    event: "updatevirtualpath", 
                    language: "en",
                    country: "au",
                    formsName: "brochure request",
                    virtualPageURL: "/lpmi/brochure-request/step2/confirmation",
                    pageName: "lpmi/other/central/B2C/new cars/desktop//request-a-brochure",
                    brand: "leapmotor",
                    siteTypeLevel1: "lpmi",
                    siteTypeLevel2: "forms",
                    siteOwner: "central",
                    siteTarget: "B2C",
                    siteFamily: "new cars",
                    pageCategory: "form page",
                    formsLeadID: "",
                    formsLeadType: "lead:brochure-request",
                    mainStepIndicator: "2",
                    mainStepName: "confirmation",
                    vehicleModelBodystyle: "",
                    vehicleModelBodystyleLabel: "C10",
                    vehicleCategory: "pc",
                    vehicleEngineType: engine_type
                });
                console.log("Leapmotor RAB - Submit");
                window.parent.postMessage("iframeFormSubmitted", "*");
            }
            if (enabled && window.parentIFrame) {
                const yr =  year !== undefined ? year : config[transformVehicle(model)].year;

                const message = {
                    'type': 'track',
                    'track': 'rab-complete',
                    'digitalData': merge(digitalData, {
                            page: {
                                pageInfo: {
                                    vehicleBrand: `${brand.name.toLowerCase()}`,
                                    vehicleModel: `${config[transformVehicle(vehicle)].displayname}`,
                                    vehicleModelYear: yr
                                },
                                component: {
                                    form: {
                                        selfReportedZip: `${postcode}`,
                                        vehiclesOfInterest: `${yr} ${vehicle}`,
                                        marketingEmailAddress : email,
                                    },
                                    vehicle: `${config[transformVehicle(vehicle)].displayname}`,
                                    year: `${yr}`,
                                    optServices: marketingOptIn ? "Yes" : "No",
                                },
                            }
                        }
                    )
                };

                window.parentIFrame.sendMessage(message);
            }
        },
        error: function () {
        }
    }

}

export function ContactUsDirectCall(brand, config , enabled = false) {
    return {
        start: function () {
            if (window._satellite) {
                window._satellite.track('cu-start');
            }
        },
        complete: function (postcode, digitalData, window) {
            if (enabled && window.parentIFrame) {

                window.parentIFrame.sendMessage({
                    type: 'track',
                    track: 'cu-complete',
                    digitalData: merge(digitalData, {
                        page: {
                            pageInfo: {
                                vehicleBrand: `${brand.name.toLowerCase()}`,
                            },
                            component: {
                                form: {
                                    selfReportedZip: `${postcode}`,
                                },
                            },
                        }
                    })
                });
            }
        },
        error: function () {
        }
    }

}

export function CompetitionDirectCall(brand, config , enabled = false){
    return {
        start: function () {
        },
        complete: function (model, year, postcode, marketingOptIn = false, email , digitalData, window) {
            if (enabled && window.parentIFrame) {
                const yr =  year !== undefined ? year : config[transformVehicle(model)].year;

                window.parentIFrame.sendMessage({
                    type: 'track',
                    track: 'competition-complete',
                    digitalData: merge(digitalData, {
                            page: {
                                pageInfo: {
                                    vehicleBrand: brand.name,
                                    vehicleName: config[transformVehicle(model)].displayname,
                                    zipCode: postcode,
                                    vehicleModel: config[transformVehicle(model)].displayname,
                                    carSize: config[transformVehicle(model)].carsize,
                                    vehicleModelYear: yr

                                },
                                component: {
                                    vehicle: model,
                                    year: yr,
                                    optServices: marketingOptIn ? "Yes" : "No",
                                    form: {
                                        selfReportedZip: postcode,
                                        vehiclesOfInterest: `${yr} ${config[transformVehicle(model)].displayname}`,
                                        marketingEmailAddress : email,

                                    }
                                },
                            }

                        }
                    )
                });
            }
        },
        error: function () {
        }
    }

}


